import { useConfig } from '@/composables/game/config'
import { computed } from 'vue'
import { useLocalStorage } from '@vueuse/core'
import { buildDropeeStorageKey } from '@/config/config'
import { usePlayerSegmenter } from '@/composables/game/player-segmenter'

export const useTaskHighlight = () => {
  const { config } = useConfig()
  const { segment } = usePlayerSegmenter()

  const highlightedTasks = computed(() => config.value.tasks.filter(task => task.categories.includes('highlight') && !task.isDone && segment(task.segmentation)))
  const closedHighlightedTasks = useLocalStorage<string[]>(buildDropeeStorageKey('closed_highlighted_tasks'), [])
  const newHighlightedTasks = computed(() => highlightedTasks.value.filter(task => !closedHighlightedTasks.value.includes(task.id)))

  function setNewTasksAsClosed() {
    closedHighlightedTasks.value = [...closedHighlightedTasks.value, ...newHighlightedTasks.value.map(task => task.id)]
  }

  return {
    newHighlightedTasks,
    setNewTasksAsClosed,
  }
}